import React, { forwardRef, ButtonHTMLAttributes } from 'react';
import 'what-input';

import { cn, ClassName } from '../../utils';
import styles from './index.module.scss';


export type ButtonVariant = 'auxiliary' | 'accent' | 'light' | 'secondary' | 'primary';
export type ButtonProps = ClassName & ButtonHTMLAttributes<HTMLButtonElement> & {
    type?: 'button' | 'submit' | 'reset';
    variant: ButtonVariant;
    compact?: boolean;
    buttonEllipsis?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
    type,
    variant, compact, buttonEllipsis,
    className, children, ...props
}, ref) => (
    <button
        ref={ref}
        type={type || 'button'}
        className={cn(
            styles.button,
            styles[variant],
            compact && styles.compact,
            className,
        )}
        {...props}
    >
        {buttonEllipsis ? (
            <div className={styles.ellipsis}>
                {children}
            </div>
        ) : children}
    </button>
));
